import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  min-width: 100%;
  min-height: 3rem;
  // margin: 0 1rem 0 0;
  padding: 1.5rem 2rem;
  // flex-direction: row;
  justify-content: right;
  gap: 1rem;
  @media(max-width:768px){
    flex-direction:column;
    width:100%;
    align-items:center;
  }
`

type IconBoxProps = {
  listView: boolean
}
export const ListViewIconBox = styled.div<IconBoxProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px;
  margin: 3px;
  background: ${IconBoxProps => (IconBoxProps.listView ? '#ffffff' : 'transparent')};
  box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);
  border-radius: 6px;
  cursor: pointer;
`

export const GridViewIconBox = styled.div<IconBoxProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px;
  margin: 3px;
  background: ${IconBoxProps => (IconBoxProps.listView ? 'transparent' : '#ffffff')};
  box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);
  border-radius: 6px;
  cursor: pointer;
`
export const IconContainer = styled.div`
  display: flex;
  background: #e8f0f7;
  border-radius: 10px;
  padding: 7px;
  @media(max-width:768px){
  display:none;
  }
`